var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg034Baggage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "29px",
    viewBox: "0 0 36 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "034-baggage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Confirmation-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JetOS-light/v3/-Bookings/Confirmation-Flow/02.2-Flight-Page-View-Trip-Details-Add-Crew",
    transform: "translate(-1431.000000, -2396.000000)",
    fill: "#19C0FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CONTENT",
    transform: "translate(330.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(45.000000, 555.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Passengers-info",
    transform: "translate(0.000000, 1270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Luggage-",
    transform: "translate(24.000000, 413.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Large",
    transform: "translate(738.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "034-baggage",
    transform: "translate(294.000000, 37.017930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6236797,4.99851562 L22.6236797,2.87971875 C22.6236797,1.29185156 21.3318281,0 19.7438203,0 L16.2564609,0 C14.6685938,0 13.3766719,1.29185156 13.3766719,2.87971875 L13.3766719,4.99851562 L10.0490625,4.99851562 L10.0490625,28.0892109 L25.9512188,28.0892109 L25.9512188,4.99851562 L22.6236797,4.99851562 L22.6236797,4.99851562 Z M20.4936328,4.99844531 L15.507,4.99844531 L15.507,2.87964844 L15.5069297,2.87964844 C15.5069297,2.46635156 15.8432344,2.13004688 16.2566016,2.13004688 L19.7439609,2.13004688 C20.1572578,2.13004688 20.4936328,2.46635156 20.4936328,2.87964844 L20.4936328,4.99844531 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0139297,4.99851562 L28.0814063,4.99851562 L28.0814063,28.0892109 L31.0139297,28.0892109 C33.7632188,28.0892109 36,25.8525 36,23.1031406 L36,9.98451562 C36,7.23522656 33.7632891,4.99851562 31.0139297,4.99851562 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91908594,4.99851562 L4.98607031,4.99851562 C2.23671094,4.99851562 0,7.23522656 0,9.98451562 L0,23.1031406 C0,25.8524297 2.23671094,28.0892109 4.98607031,28.0892109 L7.91908594,28.0892109 L7.91908594,4.99851562 Z",
    id: "Path"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg034Baggage);
export default __webpack_public_path__ + "static/media/034-baggage.892d130e.svg";
export { ForwardRef as ReactComponent };